import { BottomSheetDialog } from '@medely/web-components';
import React from 'react';
import { CancelationContent } from './CancelationContent';
import useDevice from '@mp/hooks/useDevice.web';
import { CancelShiftDialogProps } from '../interface';

export const CancelShiftDialog = ({
  open,
  onClose,
  title,
  job: inputJob,
  utmParams,
  onCancelSuccess,
}: CancelShiftDialogProps) => {
  const isDesktop = useDevice() === 'desktop';

  return (
    <BottomSheetDialog
      sx={{ alignSelf: isDesktop ? 'center' : 'end' }}
      open={open}
      onClose={onClose}
      title={title}
      content={
        <CancelationContent
          job={inputJob}
          closeDialog={onClose}
          utmParams={utmParams}
          onCancelSuccess={onCancelSuccess}
        />
      }
      isDesktop={isDesktop}
      data-testid="cancel-shift-dialog"
      fullScreen={false}
      PaperProps={
        !isDesktop
          ? { sx: { margin: 0, width: '90%', maxWidth: '100%', borderRadius: '16px 16px 0 0' } }
          : undefined
      }
    />
  );
};
